import { i18n } from "../i18n/i18n";

import React, { Component } from 'react'
import itemApi, { ItemData } from '../apis/item.api'
import Heading from '../components/Heading'
import TableHorizontal, {
  TableHorizontalData, TableHorizontalHeader
} from '../components/TableHorizontal'
import materialService from '../services/material.service'

interface Props {
  id: number
  quantity: number
}

interface State {
  materials: ItemData[]
}

export default class ItemMaterials extends Component<Props, State> {
  constructor (props: Props) {
    super(props)
    this.state = {
      materials: []
    }
  }

  get headers (): TableHorizontalHeader[] {
    return [
      { heading: i18n("Material"), path: 'code' },
      { heading: i18n("Required quantity"), path: 'requiredQuantity' },
      { heading: i18n("Available quantity"), path: 'stockQuantity' },
      { heading: i18n("Delta"), path: 'delta', delta: true }
    ]
  }

  get data (): TableHorizontalData[] {
    return materialService.itemMaterialsTableData(this.state.materials, this.props.quantity)
  }

  listMaterials () {
    itemApi.listMaterials(this.props.id, materials => {
      if (materials) this.setState({ materials })
    })
  }

  componentDidMount () {
    this.listMaterials()
  }

  render () {
    return (
      <div>
        <Heading text={i18n("Materials")} />
        <div className="mt-2">
          <TableHorizontal
            headers={this.headers}
            data={this.data} />
        </div>
      </div>
    )
  }
}
